import {Box,TextField,Typography,Button,Container,Card,CardContent,Tabs,Tab,Snackbar,Alert,Divider,} from "@mui/material";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import React, { useContext, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Update } from "../App";
import { auth, db } from "./firebase";
import { UserC } from "../components/FitFinderInfo";
import Cookies from "js-cookie";
import { doc, getDoc, setDoc } from "firebase/firestore";
import PropTypes from "prop-types";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};




const Login = () => {
  const navigate = useNavigate();
  const {setNav } = useContext(Update);

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [severity, setSeverity] = useState();
  const [value, setValue] = React.useState(0);

  let userc = new UserC();
  const password2 = useRef("");
  const email1 = useRef("");
  const email2 = useRef("");
  const password1 = useRef("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const signin = () => {
    signInWithEmailAndPassword(
      auth,
      email1.current.value,
      password1.current.value
    )
      .then((response) => {
        setSeverity("success")
        setMessage("SuccesFully Logined");
        setOpen(true);
        document.cookie = `_hash=${response.user.uid}`;
        setNav(1);
        let hash = Cookies.get("_hash");
        async function fun() {
          let a = {
            absb: [0, 0, 0],
            absi: [0, 0, 0],
            absa: [0, 0, 0],
            armb: [0, 0, 0],
            armi: [0, 0, 0],
            arma: [0, 0, 0],
            chestb: [0, 0, 0],
            chesti: [0, 0, 0],
            chesta: [0, 0, 0],
            legb: [0, 0, 0],
            legi: [0, 0, 0],
            lega: [0, 0, 0],
            backb: [0, 0, 0],
            backi: [0, 0, 0],
            backa: [0, 0, 0],
            fullbody: [0, 0, 0],
            lowerbody: [0, 0, 0],
            name: [],
          };

          try {
            await userc.setDocData(hash, a);
          } catch (err) {
            console.log(err);
          }
        }
        async function verify() {
          try {
            const a = await userc.getDocData(hash);
            if (a.data()) {
            } else {
              fun();
            }
          } catch (err) {
            console.log(err);
          }
        }
        verify();
        async function add() {
          try {
            await setDoc(doc(db, hash, "xbzmczcbckasdcsxzcsdjlcnz,"), {
              name: "nb",
            });
          } catch (err) {
            console.log(err);
          }
        }
        add();
        async function setData() {
          try {
            await setDoc(doc(db, "Chart", `${Cookies.get("_hash")}`), {
              Workout: [],
              Kcal: [],
              Time: [],
              Name: [],
            });
          } catch (err) {
            console.log(err);
          }
        }
        async function verifyChart() {
          let data;
          try {
            data = await getDoc(doc(db, "Chart", `${Cookies.get("_hash")}`));
            if (data.data()) {
            } else {
              setData();
            }
          } catch (err) {}
        }
        verifyChart();
        setTimeout(() => {
          navigate("/");
        }, 1000);
      })
      .catch((err) => {
        
        setMessage(err.message);
        setSeverity("error")
        setOpen(true);
      });
  };

  const createAccount = async () => {
    if (email2.current.value === "" || password2.current.value === "") {
      setMessage("Provide the required Info");
      setSeverity("warning")
      setOpen(true);

    } else {
      createUserWithEmailAndPassword(
        auth,
        email2.current.value,
        password2.current.value
      )
        .then((res) => {
          setSeverity("success");
          setMessage("SignUp Successfully*");
        setOpen(true);

          setTimeout(() => {
            navigate("/login");
          }, 1000);
        })
        .catch((err) => {
          if (err.message === "Firebase: Error (auth/email-already-in-use).") {
            setSeverity("warning");
            setMessage("User is already registred try to login*");
        setOpen(true);

          } else {
            setSeverity("error");
            setMessage(err.message);
        setOpen(true);

          }
        });
    }
  };

  return (
    <Container>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Card
          sx={{
            width: "500px",
            m: "100px 0px",
            boxShadow: "0 0 8px 1px black",
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              justifyContent: "center",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <Tabs value={value} onChange={handleChange}>
              <Tab label="Login" />
              <Tab label="Create Account" />
            </Tabs>
          </CardContent>
          <Divider />
          <TabPanel value={value} index={0}>
            <CardContent>Email:</CardContent>
            <CardContent>
              <TextField
              placeholder="abc@gmail.com"
                inputRef={email1}
                sx={{ width: { xs: "230px", sm: "340px", md: "400px" } }}
              />
            </CardContent>
            <CardContent>Password:</CardContent>
            <CardContent>
              <TextField
                type="password"
                inputRef={password1}
                sx={{ width: { xs: "230px", sm: "340px", md: "400px" } }}
              />
            </CardContent>
            <CardContent sx={{ textAlign: "center" }}>
              <Button variant="contained" onClick={signin}>
                Login
              </Button>
            </CardContent>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <CardContent>Email:</CardContent>
            <CardContent>
              <TextField
              placeholder="xyz@gmail.com"
                inputRef={email2}
                sx={{ width: { xs: "230px", sm: "340px", md: "400px" } }}
              />
            </CardContent>
            <CardContent>Password:</CardContent>
            <CardContent>
              <TextField
                type="password"
                inputRef={password2}
                sx={{ width: { xs: "230px", sm: "340px", md: "400px" } }}
              />
            </CardContent>
            <CardContent sx={{ textAlign: "center" }}>
              <Button variant="contained" onClick={createAccount}>
              Create Account
            </Button>
            </CardContent>
          </TabPanel>
        </Card>
      </Box>
      <Snackbar
        open={open}
        autoHideDuration={4000}
        onClose={() => {
          setOpen(false);
        }}
      >
        <Alert
          onClose={() => {
            setOpen(false);
          }}
          severity={severity}
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Login;

